import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 38,
  height: 38,
}

const Playground = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 37.354 37.354'
  >
    <g fill={color}>
      <path
        d='M353.459,332.73a.73.73,0,1,1-.73-.73A.73.73,0,0,1,353.459,332.73Zm0,0'
        transform='translate(-326.319 -307.778)'
      />
      <path
        d='M66.29,35.9H64.831a.73.73,0,0,1-.73-.73V12.551h.73a.729.729,0,0,0,.573-1.182L56.649.279a.73.73,0,0,0-1.145,0l-8.755,11.09a.73.73,0,0,0,.573,1.182h.73v7.4c-5.635.091-7.115,2.464-8.819,5.191l-3.773,6.038a.726.726,0,0,1-.619.343h-2.11a.73.73,0,0,0-.73.73v4.377a.73.73,0,0,0,.73.73h1.952a5.079,5.079,0,0,0,4.331-2.4l4.463-7.141a4.9,4.9,0,0,1,4.576-2.157v9.509a.73.73,0,0,1-.73.73H45.862a.73.73,0,1,0,0,1.459h1.459a2.191,2.191,0,0,0,2.189-2.189V25.683h1.459V36.627a.73.73,0,0,0,1.459,0V34.438h7.3v2.189a.73.73,0,1,0,1.459,0V25.683h1.459v9.485a2.191,2.191,0,0,0,2.189,2.189H66.29a.73.73,0,1,0,0-1.459ZM56.076,1.909l7.249,9.182h-14.5ZM42.237,27.042l-4.463,7.141A3.628,3.628,0,0,1,34.681,35.9H33.459V32.979h1.381A2.177,2.177,0,0,0,36.7,31.95l3.773-6.038c1.652-2.643,2.771-4.429,7.582-4.506V24.2a6.286,6.286,0,0,0-5.813,2.843Zm10.191,5.937V30.06h7.3v2.918Zm7.3-4.377h-7.3V25.683h.365a.73.73,0,0,0,0-1.459H49.51V12.551H62.642V24.224H59.359a.73.73,0,0,0,0,1.459h.365Zm0,0'
        transform='translate(-29.665 -0.002)'
      />
      <path
        d='M310.755,196.377a4.378,4.378,0,1,0-4.378,4.377A4.382,4.382,0,0,0,310.755,196.377Zm-7.3,0a2.918,2.918,0,1,1,2.918,2.918A2.922,2.922,0,0,1,303.459,196.377Zm0,0'
        transform='translate(-279.967 -177.992)'
      />
      <path d='M0,6.566A2.191,2.191,0,0,0,2.189,8.755H13.862a2.189,2.189,0,0,0,0-4.377h-.8A3.65,3.65,0,0,0,8.189,1.7,3.646,3.646,0,0,0,1.555,4.471,2.193,2.193,0,0,0,0,6.566ZM5.107,1.459a2.192,2.192,0,0,1,1.85,1.019,3.642,3.642,0,0,0-1.047,1.9H3.044A2.188,2.188,0,0,1,5.107,1.459ZM2.189,5.837H6.566a.73.73,0,0,0,.73-.73,2.189,2.189,0,0,1,4.377,0,.73.73,0,0,0,.73.73h1.459a.73.73,0,0,1,0,1.459H2.189a.73.73,0,1,1,0-1.459Zm0,0' />
    </g>
  </svg>
)

export default Playground
